import { RiPermissions, CorePermissions } from '@/constants/permissions.constant';
import { AllValues } from '@/utils/types/types.util';
import { PermissionKeyEnum } from '@/utils/types/Permission';

type RiPermissionValue = AllValues<typeof RiPermissions>;

export function loadRiPermissionsFromStorage(): RiPermissionValue[] {
  try {
    const jsonItem = localStorage.getItem(PermissionKeyEnum.Ri) ?? JSON.stringify([]);

    return JSON.parse(jsonItem);
  } catch (_error) {
    return [];
  }
}

export function savePermissionsToStorage(
  permissionKey: PermissionKeyEnum,
  permissions: AllValues<typeof RiPermissions | typeof CorePermissions>[],
) {
  localStorage.setItem(permissionKey, JSON.stringify(permissions));
}

type CorePermissionValue = AllValues<typeof CorePermissions>;

export function loadCorePermissionsFromStorage(): CorePermissionValue[] {
  const storageValue = localStorage.getItem(PermissionKeyEnum.Core);
  if (!storageValue) {
    return [CorePermissions.Tiles.FullRead];
  }

  try {
    return JSON.parse(storageValue);
  } catch (_error) {
    return [];
  }
}
